import { render, staticRenderFns } from "./AudanetSubmitItemsModal.vue?vue&type=template&id=1958fa65&scoped=true"
import script from "./AudanetSubmitItemsModal.vue?vue&type=script&lang=js"
export * from "./AudanetSubmitItemsModal.vue?vue&type=script&lang=js"
import style0 from "./AudanetSubmitItemsModal.vue?vue&type=style&index=0&id=1958fa65&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958fa65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1958fa65')) {
      api.createRecord('1958fa65', component.options)
    } else {
      api.reload('1958fa65', component.options)
    }
    module.hot.accept("./AudanetSubmitItemsModal.vue?vue&type=template&id=1958fa65&scoped=true", function () {
      api.rerender('1958fa65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AudanetSubmitItemsModal.vue"
export default component.exports